export default __webpack_public_path__ + "static/media/Crypto Convoy.4c91bcfe.png";